import { useGlobalStorageContext } from '../contexts/GlobalStorageContext';
import { useQuery } from '@tanstack/react-query';

interface HijriResponse {
  success: boolean;
  hijri_adjustment: number;
}

const fetchHijriAdjustment = async (): Promise<number> => {
  const response = await fetch('https://rukousajat.fi/api/hijri.php');
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const data: HijriResponse = await response.json();
  return data.hijri_adjustment;
};

const getHijriMonthKey = () => {
  const now = new Date();
  const islamicDate = new Intl.DateTimeFormat('en-US-u-ca-islamic', {
    year: 'numeric',
    month: 'numeric'
  }).formatToParts(now);
  const year = islamicDate.find(p => p.type === 'year')?.value;
  const month = islamicDate.find(p => p.type === 'month')?.value;
  return `hijri_last_fetch_${year}_${month}`;
};

export const useHijriAdjustment = () => {
  const { setHijriAdjustment } = useGlobalStorageContext();
  const monthKey = getHijriMonthKey();
  const hasFetched = localStorage.getItem(monthKey) === 'true';
  
  const query = useQuery({
    queryKey: ['hijriAdjustment', monthKey],
    queryFn: async () => {
      const adjustment = await fetchHijriAdjustment();
      setHijriAdjustment(adjustment);
      localStorage.setItem(monthKey, 'true');
      return adjustment;
    },
    enabled: !hasFetched,
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
  });
  
  if (query.error) {
    console.error('Hijri fetch error:', query.error);
  }
  
  return query;
};
